export const getErrorMessageKey = (
  errorCode: string | number,
  isMerchantContext?: boolean
): string =>
  `${isMerchantContext ? 'merchant.' : ''}payment_error_${errorCode}`;
